import { DispatchProvider } from "./providers/DispatchProvider";
import DispatchLayout from "./DispatchLayout";

export default function DispatchPage() {
  return (
    <DispatchProvider>
      <DispatchLayout />
    </DispatchProvider>
  );
}